<ngx-spinner bdOpacity="1" bdColor="rgba(97,197,212,0.07)" size="medium" color="#dd4b39" type="ball-spin-clockwise"
    fullScreen="true">
    <p style="color: #61c5d4;">Loading..</p>
</ngx-spinner>


<div class="main-container">
  <div class="login-container">
    <div class="left-container"></div>
    <div class="right-container"></div>
    <div class="sign-container">
      <div class="left-sign-container">
        <div class="form-container">
          <div class="formHeading">
            <div class="leftHeading">
              <span style = "font-size: 20px;margin-bottom: 16px;" class="poly-regular">Welcome to iCeipts</span>
              <span style = "font-size: 30px;" class="poly-regular">Sign In</span>
            </div>
            <div class="rightHeading">
              <div *ngIf="!showEmployeeForm">
                <div>
                  <span *ngIf="showLoginForm" class="poly-regular">For New Account?</span>
                </div>
                <div>
                  <span *ngIf="!showLoginForm" class="poly-regular">For New Account?</span>
                </div>
              </div>
              <div *ngIf="showEmployeeForm"></div>
              <div *ngIf="!showEmployeeForm">
                <div *ngIf="showLoginForm" style = "cursor: pointer;color:red;">
                  <span (click)="onRetailerRegisterClick()" class="poly-regular">
                    Register here!
                  </span>
                </div>
                <div *ngIf="!showLoginForm" style = "cursor: pointer;color:red;">
                  <span (click)="onCustomerRegisterClick()" class="poly-regular">
                    Register here!
                  </span>
                </div>
              </div>
              <div *ngIf="showEmployeeForm">
                <span (click)="onCustomerRegisterClick()" style="visibility:hidden;">For New Account?</span>
              </div>
            </div>
          </div>
          <div class="login-forms">
            <div class="form-group">
              <label class="form-label mb-4" for="domain" style="font-family: 'Poly';">Select Domain <span class="error-asterisk">*</span></label>
              <select id="domain" class="form-select form-control custom-width mt-2" [(ngModel)]="role" name="domain" required (ngModelChange)="onRoleChange($event)" [ngClass]="{ 'is-invalid': !role && submitted }">
                <option *ngFor="let option of roles" [value]="option" selected="true" style="font-family: 'Poly';">{{ option }}</option>
              </select>
            </div>
            <div *ngIf="!showEmployeeForm">
              <div *ngIf="showLoginForm" class="retailerForm">
                <app-login [UserType]="this.role" [CustLogintoggle]="false"></app-login>
              </div>
              <div *ngIf="!showLoginForm" class="customerForm">
                <app-login [UserType]="this.role" [CustLogintoggle]="true"></app-login>
              </div>
            </div>
            <div  *ngIf="showEmployeeForm" class="employeeForm">
              <app-login-employee [UserType]="this.role"  ></app-login-employee>
            </div>
          </div>
        </div>
      </div>
      <div class="right-sign-container">
        <img src = "../../../../assets/img/dashboard-party-profiles/login-pic.png"
        class="logic-pic">
      </div>
    </div>
  </div>
</div>

